import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const doaApi = createApi({
  baseQuery,
  reducerPath: 'doaApi',
  endpoints: builder => ({
    getDOALinkData: builder.query<any, any>({
      query: ({ site_id, study_id, country, application }) => ({
        url: `${formatString(
          endPoints.DOA.getAll,
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.site_id, value: site_id }
        )}?country=${country}&application=${application}`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateLinkSignature: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, id, data }) => ({
        url: `${formatString(endPoints.DOA.updateSignature, {
          key: urlKeys.id,
          value: id
        })}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=${application}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getPageLevelSignData: builder.query<any, any>({
      query: ({ site_id, study_id, country, application, application_module_section }) => ({
        url: `${formatString(
          endPoints.DOA.getPageLevelSignature,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&application_module_section=${application_module_section}`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updatePageLevelSignature: builder.query<any, any>({
      query: ({ site_id, study_id, country, username, password, application, data, application_module_section }) => ({
        url: `${formatString(
          endPoints.DOA.updatePageLevelSignature,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&username=${username}&password=${password}&application=${application}&application_module_section=${application_module_section}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateDoaLink: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, id, data }) => ({
        url: `${formatString(endPoints.DOA.doaLinkUpdate, {
          key: urlKeys.id,
          value: id
        })}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=${application}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    deleteDoaLink: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, id, data }) => ({
        url: `${formatString(endPoints.DOA.doaLinkDelete, {
          key: urlKeys.id,
          value: id
        })}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=${application}`,
        method: 'PATCH',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    createDoaLink: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, data }) => ({
        url: `${formatString(
          endPoints.DOA.doaLinkcreate,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    publishDOAtoISF: builder.mutation<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        application,
        data,
        application_module_section,
        isUpdate,
        isSubmit,
        publish_doc_version
      }) => ({
        url: `${formatString(
          endPoints.DOA.publishToIsf,
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.site_id, value: site_id }
        )}?update=${isUpdate}&is_submit=${isSubmit}&site_id=${site_id}&study_id=${study_id}&country=${country}&publish_doc_version=${publish_doc_version}&application=${application}&application_module_section=${application_module_section}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updatePublishDOAtoISF: builder.mutation<any, any>({
      query: ({ site_id, study_id, data, isSubmit }) => ({
        url: `${formatString(
          endPoints.DOA.updatePublishToIsf,
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.site_id, value: site_id }
        )}?is_submit=${isSubmit}&site_id=${site_id}&study_id=${study_id}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const {
  useGetDOALinkDataQuery,
  useLazyGetDOALinkDataQuery,
  useUpdateLinkSignatureMutation,
  useLazyGetPageLevelSignDataQuery,
  useLazyUpdatePageLevelSignatureQuery,
  useUpdateDoaLinkMutation,
  useCreateDoaLinkMutation,
  useDeleteDoaLinkMutation,
  usePublishDOAtoISFMutation,
  useUpdatePublishDOAtoISFMutation
} = doaApi;
